import { render, staticRenderFns } from "./RevokeModalResponseError.vue?vue&type=template&id=55b269cc"
import script from "./RevokeModalResponseError.vue?vue&type=script&lang=js"
export * from "./RevokeModalResponseError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports